export default __webpack_public_path__ + "5960ca059c07aceb76a42d219b40c257.svg";